import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    checkEntrance: false,
    socket: null,
    peerInfo: {},
    streamInfo: {},
    roomInfo: {},
    userInfo: {},
    showsSpeaker: false,
    language: '',
    videoOnMembers: [],
    videoOffMembers: [],
    videoStatus: {},
    highResolution: false
  },
  mutations: {
    setSocketIo(state, socket) {
      state.socket = socket;
    },
    setPeerInfo(state, peer) {
      Object.assign(state.peerInfo, peer);
    },
    removePeerInfo(state, name) {
      if (state.peerInfo[name]) {
        state.peerInfo[name].close();
        delete state.peerInfo[name];
      }

      console.log(name, 'ivypark peerInfo ----> ', state.peerInfo);
    },
    setStreamInfo(state, info) {
      Object.assign(state.streamInfo, info);
    },
    removeStreamInfo(state, name) {
      if (state.streamInfo[name]) {
        state.streamInfo[name].getTracks().forEach(track => {
          state.streamInfo[name].removeTrack(track); // 210303 모바일웹 종료 이슈 수정
          track.stop();
        });

        delete state.streamInfo[name];
      }

      console.log(name, 'ivypark streaminfo ----> ', state.streamInfo);
    },
    setRoomInfo(state, info) {
      Object.assign(state.roomInfo, info);
    },
    setUserInfo(state, info) {
      Object.assign(state.userInfo, info);
    },
    setLanguage(state, info) {
      state.language = info;
    },
    setShowsSpeaker(state, shows) {
      // 화자감지 기능 on/off
      state.showsSpeaker = shows;
    },
    clearAll(state) {
      if (Object.keys(state.streamInfo).length > 0) {
        for (let c in state.streamInfo) {
          state.streamInfo[c].getTracks().forEach(track => {
            state.streamInfo[c].removeTrack(track); // 210303 모바일웹 종료 이슈 수정
            track.stop();
          });
        }
        state.streamInfo = {};
      }

      for (let c in state.peerInfo) {
        state.peerInfo[c].close();
        delete state.peerInfo[c];
      }

      state.userInfo = {};
      state.roomInfo = {}
      if (state.socket) state.socket.close();
      state.socket = null;
      state.videoOnMembers = [];
      state.videoOffMembers = [];

      state.showsSpeaker = false;
      state.highResolution = false;
      state.language = '';
      state.videoStatus = {};
      state.checkEntrance = false;
    },
    setVideoOnMembers(state, info){
      state.videoOnMembers = info;
    },
    setVideoOffMembers(state, info){
      state.videoOffMembers = info;
    },
    setVideoStatus(state, info) {
      if (!state.videoStatus[info.userId]) {
        state.videoStatus[info.userId] = { cam: info.cam, audioSafe: info.audioSafe, blur: info.blur, camOff: info.camOff, micOff: info.micOff };
      } else {
        if (info.hasOwnProperty('cam')) state.videoStatus[info.userId].cam = info.cam;
        if (info.hasOwnProperty('audioSafe')) state.videoStatus[info.userId].audioSafe = info.audioSafe;
        if (info.hasOwnProperty('blur')) state.videoStatus[info.userId].blur = info.blur;
        if (info.hasOwnProperty('camOff')) state.videoStatus[info.userId].camOff = info.camOff;
        if (info.hasOwnProperty('micOff')) state.videoStatus[info.userId].micOff = info.micOff;
      }
      // state.videoStatus[info.userId] = { cam: info.cam, audioSafe: info.audioSafe, blur: info.blur, mic: info.mic };
    },
    setResolution(state, resolution) {
      state.highResolution = resolution === 'high' ? true : false;
    },
    checkEntrance(state, checkEntrance) {
      state.checkEntrance = checkEntrance;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js